import React from 'react';

interface AlertModalProps {
    message: string;
    confirm: string;
    onClick: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({ message, confirm, onClick }) => {
    return (
        <div>
            <p className='mb-2'>{message}</p>
            <a
                className='msc-cta__primary'
                onClick={() => {
                    onClick();
                }}
            >
                {confirm}
            </a>
        </div>
    );
};

export default AlertModal;
